import { z } from 'zod';
import { CareDocumentType } from '../../enums';
import { IObject } from '../../IObject';
import { dateValidation, fullNameValidation } from '../../../validation';

export const CareDocumentDataSchema = z.object({
  type: z.enum(CareDocumentType),
  caseId: z.string().min(1),
  storageRef: z.string().optional(),
  patient: z.object({
    fullName: fullNameValidation('Patient name is required'),
  }),
  sentToPlatform: z
    .object({
      at: dateValidation(),
      by: z.string().nullish(),
    })
    .optional(),
});

export type CareDocumentData = z.infer<typeof CareDocumentDataSchema>;
export type CareDocument = IObject.HasIdTimestamped<CareDocumentData>;
